import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F4EC] flex items-center justify-center px-6" data-testid="forgot-password-page">
      <div className="max-w-sm w-full bg-[#FFFDF9] rounded-2xl border border-[rgba(58,42,37,0.08)] shadow-[0_20px_50px_rgba(58,42,37,0.08)] p-10">
        <p className="font-serif-display text-2xl tracking-[0.25em] text-[#3A2A25] text-center">CELUSTA</p>
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#C9A45C] text-center mt-2 mb-8">Reset Password</p>
        {sent ? (
          <p className="text-sm font-light leading-relaxed text-[#756A64] text-center" data-testid="forgot-password-sent-message">
            If this email belongs to an admin account, a reset link has been sent. The link is valid for 1 hour.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Admin email"
              required
              className="w-full bg-[#F8F4EC] border border-[rgba(58,42,37,0.15)] rounded-lg px-4 py-3 text-sm text-[#2B1F1B] placeholder:text-[#9A8D85] focus:outline-none focus:border-[#3A2A25] transition-colors duration-300"
              data-testid="forgot-email-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full px-8 py-3.5 bg-[#3A2A25] text-white text-xs font-semibold uppercase tracking-[0.2em] rounded-full hover:bg-[#55423A] transition-colors duration-300 disabled:opacity-50 flex items-center justify-center gap-2"
              data-testid="forgot-submit-button"
            >
              {loading ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />}
              Send Reset Link
            </button>
          </form>
        )}
        <Link to="/admin/login" className="block text-center mt-6 text-xs text-[#C9A45C] hover:underline" data-testid="back-to-login-link">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
